import { svg } from 'd3'
import { FC, SVGProps, useMemo } from 'react'
import { UseChartContext } from 'components/atoms/chart/useChart'

type ChartLineProps =
  & SVGProps<SVGPathElement>
  & {
    context: UseChartContext
  }
export const ChartLine: FC<ChartLineProps> = (props) => {
  const { context, ...restProps } = props

  const lineGenerator = useMemo(() => {
    return svg.line()
      .x((item) => context.scaleX(item[0]))
      .y((item) => context.scaleY(item[1]))
  }, [context])

  const pathD = useMemo(() => {
    if (!lineGenerator) {
      return null
    }
    return lineGenerator(context.points)
  }, [context.points, lineGenerator])

  if (!pathD) {
    return null
  }

  return (
    <path d={ pathD } { ...restProps } strokeLinejoin='round' />
  )
}
